import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import SuccessIcon from "~images/ic_check_circle_24px@3x.png";

interface SuccessDialogProps {
  openDialog: boolean;
  value: string;
}

const useStyles = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    flexDirection: "column",
  },
  icon: {
    width: "25%",
    alignSelf: "center",
    paddingBottom: "5%",
  },
  button: {
    alignSelf: "center",
  },
}));

const SuccessDialog: React.FC<SuccessDialogProps> = ({ openDialog, value }) => {
  const [open, setOpen] = useState(openDialog);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
    //return <Redirect to={`${paths[solicitudesEmisionIndex]}`} />;
  };

  useEffect(() => {
    setOpen(openDialog);
  }, [openDialog]);

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <div className={classes.dialogTitle}>
            <img alt="" src={SuccessIcon} className={classes.icon} />
            {value}
          </div>
        </DialogTitle>
      </Dialog>
    </div>
  );
};

export default SuccessDialog;
